import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';

const HeroSection = () => {
  const { t } = useLanguage();
  const [currentSlide, setCurrentSlide] = useState(0);
  const videoRef = useRef(null);
  
  // Video MP4 directo
  const heroVideo = "https://customer-assets.emergentagent.com/job_wanderwise-86/artifacts/k6tgtlo2_robles_edgardo01_20260127_1.mp4";
  
  const heroImages = [
    "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/Isla-Catalina-1357x905px-Stay-Happy-RD-4.jpg",
    "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/SAONA-CRUSOE-VIP-1-1357x905.jpg",
    "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/Excursion-Isla-Saona-Premium-1357x905px-Stay-Happy-RD-2-2.jpg"
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(e => console.log('Autoplay prevented:', e));
    }
  }, []);

  const scrollToTours = () => {
    const toursSection = document.getElementById('excursiones');
    if (toursSection) {
      toursSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={heroVideo} type="video/mp4" />
      </video>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />
      
      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
          {t('heroTitle')}
        </h1>
        <p className="text-base sm:text-lg md:text-xl mb-8 text-white/90 max-w-2xl mx-auto">
          {t('heroSubtitle')}
        </p>
        <button 
          onClick={scrollToTours}
          className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-3 rounded-lg transition-all transform hover:scale-105 shadow-lg"
        >
          {t('heroButton')}
        </button>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              currentSlide === index ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
